<template>
  <div class="q-ml-md" style="height: '100%'">
    <div class="row align">
      <modal
        @unidade="getFiltros"
        :loadingValue="loadingValue"
        :tipoSelecao="'multiple'"
        :tipoRelatorio="'Consumo'"
        :regiao="true"
      />
      <p class="text-h6 text-brand-5 text-weight-bold q-mt-md">
        Relatório de Consumo
      </p>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :exportName="'Consumo'"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      @enviarRespostaEp="getRelatorioSalvo"
      @flexmonsterLoading="loadingStop"
      :salvarType="'consumo'"
    />
    <q-dialog persistent v-model="showComentarioMovimentacao">
      <q-card style="height: 220px; width: 450px">
        <q-card-section class="column">
          <span style="color: #21324a" class="mensagem-text">Aviso</span>
          <q-separator style="height: 1px; background-color: #21324a" />
        </q-card-section>

        <q-card-section style="min-height: 70px">
          <span style="color: #21324a">
            Seu relatório excedeu o tempo para geração automático, aguarde o
            link na central de notificações pra download do relatório
            completo.</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            label="Confirmar"
            :disabled="desabilitarConfirme"
            no-caps
            icon="done"
            @click="openModal++"
            v-close-popup
            style="
              background-color: #21324a;
              border-radius: 8px;
              color: white;
              font-weight: normal;
            "
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import Flexmonster from "../components/Flexmonster.vue";
import Modal from "../components/Modal.vue";

import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { defineComponent, ref, onMounted } from "vue";
export default defineComponent({
  name: "CompositionAPIDemo",
  components: {
    Flexmonster,
    Modal,
  },
  setup() {
    const route = useRoute();
    const id = route.params.id;
    const loadingValue = ref("");
    const store = useStore();
    const link = ref("");
    const quasar = useQuasar();
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const showComentarioMovimentacao = ref(false);
    const filtrosObject = ref(null);
    const types = ref({
      SolicitanteSap: {
        type: "string",
      },
      CriacaoSap: {
        type: "string",
      },
      RetiradoPorSap: {
        type: "string",
      },
      FinalizacaoSap: {
        type: "string",
      },
      DataCompleta: {
        type: "string",
      },
      CriadaEm: {
        type: "string",
      },
      CriacaoData: {
        type: "string",
      },
      AprovacaoData: {
        type: "string",
      },
      FinalizacaoData: {
        type: "string",
      },
      RetiradoPorData: {
        type: "string",
      },
      EntregueEM: {
        type: "string",
      },
      ItemCaValidade: {
        type: "string",
      },
      Ano: {
        type: "number",
      },
      Mes: {
        type: "string",
      },
      Dia: {
        type: "number",
      },
      Janeiro: { parent: "Mes", value: 1 },
      Fevereiro: { parent: "Mes", value: 2 },
      Março: { parent: "Mes", value: 3 },
      Abril: { parent: "Mes", value: 4 },
      Maio: { parent: "Mes", value: 5 },
      Junho: { parent: "Mes", value: 6 },
      Julho: { parent: "Mes", value: 7 },
      Agosto: { parent: "Mes", value: 8 },
      Setembro: { parent: "Mes", value: 9 },
      Outubro: { parent: "Mes", value: 10 },
      Novembro: { parent: "Mes", value: 11 },
      Dezembro: { parent: "Mes", value: 12 },
    });
    const layout = ref("flat");
    const updateLink = ref(0);
    const slice = ref({
      columns: "",
      rows: [{ uniqueName: "EntregaUnidadeNome" }],
      reportFilters: "",
      measures: [
        { uniqueName: "RequisicaoNumero", aggregation: "distinctcount" },
        { uniqueName: "CriadaEm" },
        { uniqueName: "DataCompleta" },
        { uniqueName: "Ano" },
        { uniqueName: "Mes" },
        { uniqueName: "Dia" },
        { uniqueName: "SolicitanteNome" },
        { uniqueName: "SolicitanteSap" },
        { uniqueName: "SolicitanteEmail" },
        { uniqueName: "SolicitanteCargo" },
        { uniqueName: "Solicitante_funcao_id" },
        { uniqueName: "Solicitante_funcao_code" },
        { uniqueName: "SolicitanteFuncao" },
        { uniqueName: "Turno" },
        { uniqueName: "ItemCodigo" },
        { uniqueName: "ItemNome" },
        { uniqueName: "ItemNomeContrato" },
        { uniqueName: "ItemCaCodigo" },
        { uniqueName: "ItemCaValidade" },
        { uniqueName: "ItemCategoriaCodigo" },
        { uniqueName: "ItemCategoriaDescricao" },
        { uniqueName: "ItemGrupoNome" },
        { uniqueName: "ItemGrupoDescricao" },
        { uniqueName: "ItemEpi" },
        { uniqueName: "ItemQuantidade" },
        { uniqueName: "ItemPreco" },
        { uniqueName: "ValorTotal" },
        { uniqueName: "CentroCustoCodigo" },
        { uniqueName: "CentroCustoNome" },
        { uniqueName: "CentroCustoUnidade" },
        { uniqueName: "CriacaoData" },
        { uniqueName: "CriacaoAutenticacaoTipo" },
        { uniqueName: "CriacaoNome" },
        { uniqueName: "CriacaoSap" },
        { uniqueName: "CriacaoEmail" },
        { uniqueName: "comentarioCriacao" },
        { uniqueName: "AprovacaoData" },
        { uniqueName: "AprovacaoAutenticacaoTipo" },
        { uniqueName: "AprovacaoNome" },
        { uniqueName: "AprovacaoSap" },
        { uniqueName: "AprovacaoEmail" },
        { uniqueName: "comentarioAprovacao" },
        { uniqueName: "FinalizacaoData" },
        { uniqueName: "FinalizacaoAutenticacaoTipo" },
        { uniqueName: "FinalizacaoNome" },
        { uniqueName: "FinalizacaoSap" },
        { uniqueName: "FinalizacaoEmail" },
        { uniqueName: "comentarioFinalizacao" },
        { uniqueName: "RetiradoPorData" },
        { uniqueName: "RetiradoPorAutenticacaoTipo" },
        { uniqueName: "RetiradoPorNome" },
        { uniqueName: "RetiradoPorSap" },
        { uniqueName: "RetiradoPorEmail" },
        { uniqueName: "EntregueEM" },
        { uniqueName: "MotivoRetirada" },
        { uniqueName: "ItemRegraDescricao" },
        { uniqueName: "ItemRegraPrazoMaximo" },
        { uniqueName: "ItemRegraPrazoMinimo" },
        { uniqueName: "ItemRegraQuantidadeMaxima" },
        { uniqueName: "ItemCondicaoRetirada" },
        { uniqueName: "Status" },
      ],
    });
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");

    const getFiltros = async (value) => {
      if (value.data1.from == "" || value.unidadeSelecionada.value == "") {
        quasar.notify({
          message: "Preencha todos os campos do filtro",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        return;
      }

      loadingValue.value = true;
      let unidadesID = [];
      value.unidadeSelecionada.forEach(async (e) => {
        unidadesID.push(e.id);
      });
      try {
        filtrosObject.value = {
          data_finalizacao_inicial: value.data1.from,
          data_finalizacao_final: value.data1.to,
          unidade_ids: unidadesID.join(","),
          regiao: value.regiao,
        };

        const response = await store.dispatch("rel/getConsumo", {
          data_finalizacao_inicial: value.data1.from,
          data_finalizacao_final: value.data1.to,
          unidade_ids: unidadesID.join(","),
          regiao: value.regiao,
          categoria_produto_codigo: value.categoria_produto_codigo,
          grupo_produto_nome: value.grupo_produto_nome,
        });
        filtros.value = JSON.stringify(filtrosObject);
        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;
      } catch (error) {
        console.log(error);
        if (error?.response?.status == undefined) {
          showComentarioMovimentacao.value = !showComentarioMovimentacao.value;
          getRelatorioSecundario();
        }
      }
    };
    const getRelatorioSecundario = async () => {
      loadingValue.value = true;

      const response = await store.dispatch("rel/getConsumo", {
        data_finalizacao_inicial: filtrosObject.value.data_finalizacao_inicial,
        data_finalizacao_final: filtrosObject.value.data_finalizacao_final,
        unidade_ids: filtrosObject.value.unidade_ids,
        regiao: filtrosObject.value.regiao,
        background: 1,
      });

      link.value = response.data.resultado.dados;
      updateLink.value++;
      loadingValue.value = false;
      exibir.value = true;
      url.value = response?.request?.responseURL;
    };
    const relatorioLink = route.query.id;
    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        loadingValue.value = true;
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;

          const responseCarregado = await store.dispatch("rel/getCarregado", {
            url: dados.value.url.replace(
              /(?<=\/\/)[^.]+/,
              store.state.autenticacao.cliente[0]
            ),
          });

          link.value = responseCarregado.data.return.url;
          updateLink.value++;
          exibir.value = true;
          loadingValue.value = false;
        } catch (error) {
          console.log(error);
          loadingValue.value = false;
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        console.log(dados.value);
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        if (store.state.rel.aguardandoFiltros) {
          store.commit("rel/SET_AGUARDANDO_FILTROS", false);
          return;
        }

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }
      if (
        relatorioLink != "" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = response.return.url;

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    onMounted(verificarUrl);

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    return {
      slice,
      getFiltros,
      exibir,
      link,
      loadingValue,
      filtros,
      getRelatorioSalvo,
      showGrandTotals,
      types,
      layout,
      updateLink,
      url,
      showTotals,
      urlEp,
      formats,
      loadingStop,
      gerarCsv,
      dados,
      filtrosObject,
      showComentarioMovimentacao,
    };
  },
});
</script>

<style scoped>
.align {
  align-items: center !important;
}
</style>
